import { getTimeUntilTargetDate, MS_PER_DAY } from "@/lib/date";

export default function getCountdownTime(startDateString: string | Date) {
  // start time is always 12:00 AM on the start date
  // increase by 23 hours and 59 minutes so that the banner appears for the full day
  if (!startDateString) {
    return null;
  }

  const startDate =
    typeof startDateString === "string"
      ? new Date(startDateString)
      : startDateString;

  if (!(startDate instanceof Date) || Number.isNaN(startDate.getTime())) {
    return null;
  }

  startDate.setTime(startDate.getTime() + (MS_PER_DAY - 1));
  return getTimeUntilTargetDate(startDate);
}
